module.exports = __webpack_public_path__ + "img/pic_warnings.1768119790257.png";